var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpeedDots(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6673 20.667C24.5083 20.667 26.0007 22.1594 26.0007 24.0003C26.0007 25.8413 24.5083 27.3337 22.6673 27.3337C20.8264 27.3337 19.334 25.8413 19.334 24.0003C19.334 22.1594 20.8264 20.667 22.6673 20.667Z",
    fill: "#DB443A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 21.333C16.1395 21.333 17.3333 22.5269 17.3333 23.9997C17.3333 25.4725 16.1395 26.6663 14.6667 26.6663C13.1939 26.6663 12 25.4725 12 23.9997C12 22.5269 13.1939 21.333 14.6667 21.333Z",
    fill: "#DB443A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 22C9.10457 22 10 22.8955 10 24C10 25.1045 9.10457 26 8 26C6.89543 26 6 25.1045 6 24C6 22.8955 6.89543 22 8 22Z",
    fill: "#DB443A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6673 12.667C24.5083 12.667 26.0007 14.1594 26.0007 16.0003C26.0007 17.8413 24.5083 19.3337 22.6673 19.3337C20.8264 19.3337 19.334 17.8413 19.334 16.0003C19.334 14.1594 20.8264 12.667 22.6673 12.667Z",
    fill: "#DB443A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 13.333C16.1395 13.333 17.3333 14.5269 17.3333 15.9997C17.3333 17.4725 16.1395 18.6663 14.6667 18.6663C13.1939 18.6663 12 17.4725 12 15.9997C12 14.5269 13.1939 13.333 14.6667 13.333Z",
    fill: "#DB443A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14C9.10457 14 10 14.8955 10 16C10 17.1045 9.10457 18 8 18C6.89543 18 6 17.1045 6 16C6 14.8955 6.89543 14 8 14Z",
    fill: "#DB443A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6673 4.66699C24.5083 4.66699 26.0007 6.15938 26.0007 8.00033C26.0007 9.84127 24.5083 11.3337 22.6673 11.3337C20.8264 11.3337 19.334 9.84127 19.334 8.00033C19.334 6.15938 20.8264 4.66699 22.6673 4.66699Z",
    fill: "#DB443A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 5.33301C16.1395 5.33301 17.3333 6.52691 17.3333 7.99967C17.3333 9.47243 16.1395 10.6663 14.6667 10.6663C13.1939 10.6663 12 9.47243 12 7.99967C12 6.52691 13.1939 5.33301 14.6667 5.33301Z",
    fill: "#DB443A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6C9.10457 6 10 6.89543 10 8C10 9.10457 9.10457 10 8 10C6.89543 10 6 9.10457 6 8C6 6.89543 6.89543 6 8 6Z",
    fill: "#DB443A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeedDots);
export default __webpack_public_path__ + "static/media/speed_dots.35ae88ff61b41e5aeabd40c55ad81a72.svg";
export { ForwardRef as ReactComponent };